export default "__VITE_ASSET__DHpXo8N8__"